/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Input, Button, Table, Row, message } from "antd";
import { useNavigate } from "react-router";

import { serialNum, capitalize } from "../../../utils";
import urls from "../../../api/urls";
import API from "../../../api";

import search_icon from "../../../assests/images/search-icon.svg";
import print_icon from "../../../assests/images/master/print.svg";
import checkIcon from "../../../assests/images/SVG/check.svg";

import "./style.scss";
import Heading from "../../../components/Heading";
// import { filter } from "fuzzy";
const { GET_LCR_IN_SCAN_LIST, UPDATE_ALL_BAGs } = urls;

const InScanLCRList = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataSource, setdataSource] = useState(tableData);

  const [inputSearchValue, setInputSearchValue] = useState("");

  const [total, setTotal] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(0);

  const HUB_INSCANNED_LABEL = "HUB-IN-SCANNED";
  let mockData = [
    {
      lcrNum: 8277532196,
      fromDate: "2023-05-23 12:48:50",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "OUTSCAN",
      barcode: 23200000434,
      isBag: true,
      isShipment: null,
      barcodeStatus: "HUB-OUTSCAN",
    },
    {
      lcrNum: 7154792461,
      fromDate: "2023-05-23 10:29:42",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 2,
      status: "OUTSCAN",
      barcode: 23200000433,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7154792461,
      fromDate: "2023-05-23 10:29:42",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 2,
      status: "OUTSCAN",
      barcode: 23200000432,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 4717473617,
      fromDate: "2023-05-23 10:08:47",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "IN-SCANNED",
      barcode: 23200000431,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 5540986851,
      fromDate: "2023-05-23 09:41:48",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "IN-SCANNED",
      barcode: 23200000430,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 3829812741,
      fromDate: "2023-05-23 00:51:50",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "IN-SCANNED",
      barcode: 22210000095,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7924118784,
      fromDate: "2023-05-15 09:24:34",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 2,
      status: "OUTSCAN",
      barcode: 23200000418,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7924118784,
      fromDate: "2023-05-15 09:24:34",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 2,
      status: "OUTSCAN",
      barcode: 23200000417,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7181625449,
      fromDate: "2023-05-11 17:38:16",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "OUTSCAN",
      barcode: 23200000155,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 6634919600,
      fromDate: "2023-05-10 20:01:32",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 5,
      status: "OUTSCAN",
      barcode: 23200000105,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 6634919600,
      fromDate: "2023-05-10 20:01:32",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 5,
      status: "OUTSCAN",
      barcode: 23200000157,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 6634919600,
      fromDate: "2023-05-10 20:01:32",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 5,
      status: "OUTSCAN",
      barcode: 23200000152,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 6634919600,
      fromDate: "2023-05-10 20:01:32",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 5,
      status: "OUTSCAN",
      barcode: 23200000158,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 6634919600,
      fromDate: "2023-05-10 20:01:32",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 5,
      status: "OUTSCAN",
      barcode: 23200000154,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7493862584,
      fromDate: "2023-05-04 16:19:13",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 3,
      status: "OUTSCAN",
      barcode: 23200000115,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7493862584,
      fromDate: "2023-05-04 16:19:13",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 3,
      status: "OUTSCAN",
      barcode: 23200000114,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 7493862584,
      fromDate: "2023-05-04 16:19:13",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 3,
      status: "OUTSCAN",
      barcode: 23200000113,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 4084203266,
      fromDate: "2023-05-04 14:54:22",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "OUTSCAN",
      barcode: 23200000121,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 5052018439,
      fromDate: "2023-04-24 16:43:50",
      fromPremiseId: 52,
      toPremiseId: 114,
      travelBy: "AIR",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "OUTSCAN",
      barcode: 23200000411,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 2345246070,
      fromDate: "2023-04-23 16:11:53",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "IN-SCANNED",
      barcode: 23200000118,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 1633028917,
      fromDate: "2023-04-21 16:52:01",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "IN-SCANNED",
      barcode: 23200000120,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
    {
      lcrNum: 8978371385,
      fromDate: "2023-04-21 15:46:59",
      fromPremiseId: 23,
      toPremiseId: 114,
      travelBy: "SURFACE",
      vehicleNum: "KA04AM1993",
      driverName: "Anil Kumar",
      shipmentNum: 0,
      bagNum: 1,
      status: "IN-SCANNED",
      barcode: 23200000111,
      isBag: true,
      isShipment: null,
      barcodeStatus: null,
    },
  ];

  useEffect(() => {
    getLcrInscanList();
  }, []);

  const getLcrInscanList = async () => {
    setLoading(true);

    let response = await API.Api(GET_LCR_IN_SCAN_LIST).getWithPremiseIdHeader();
    console.log(response,"response");
    if (response.status) {
      setLoading(false);
      setTableData(response?.response?.data);
      setTotal(response?.response?.data.length);
    }
    if (!response.status) {
      setLoading(false);
      message.error(response?.response?.data.message || "Network error");
    }
  };

  const filterData = () => {
    const unique = [
      ...new Map(tableData?.map((item) => [item["lcrNum"], item])).values(),
    ];

    const data = unique?.map((val) => {
      return { text: val.lcrNum, value: val.lcrNum };
    });
    return data;
  };

  function handleIdClick(val, barcode) {
    if (val.barcodeStatus === HUB_INSCANNED_LABEL && val.isBag) {
      navigate("/bag-contents/" + barcode);
    }
  }

  const checkStatus = (val) => {
    return val?.barcodeStatus === HUB_INSCANNED_LABEL && val.isBag;
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Bag ID/ Individul shipment",
      dataIndex: "barcode",
      key: "barcode",
      render: (text, val) => (
        <div
          // onClick={() => navigate("/lcr-packets-scan/" + text)}
          className="align-center"
        >
          <span
            className={checkStatus(val) ? "mr-1 pointer" : "mr-1"}
            style={{
              color: checkStatus(val) ? "#4394d3" : "",
            }}
            onClick={() => handleIdClick(val, text)}
          >
            {text}
          </span>
          {checkStatus(val) ? <img src={checkIcon} className="ml-1" /> : null}
        </div>
      ),
    },

    {
      title: "LCR ID",
      dataIndex: "lcrNum",
      key: "lcrNum",
      filters: filterData(),
      onFilter: (value, record) => record?.lcrNum === value,
      render: (text, res) => (
        <div
          // onClick={() => navigate("/lcr-packets-scan/" + text)}
          className="align-center"
        >
          {text}
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "fromDate",
      key: "fromDate",
      
      render: (text) => (
        <div style={{width:"100px"}}>
          {text?.split(" ")[0].split("-").reverse().join("-")}
        </div>
      ),
    },
    
    {
      title: "CP",
      dataIndex: "fromHub",
      key: "fromHub",
      render: (text) => <div>{capitalize(text)}</div>,
    },
    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <div>{capitalize(text)}</div>,
    },
    {
      title: "No of Bag(s)",
      dataIndex: "bagNum",
      key: "bagNum",
    },
    {
      title: "No of shipment(s)",
      dataIndex: "shipmentNum",
      key: "shipmentNum",
    },

    {
      title: "From Hub",
      dataIndex: "fromHub",
      key: "fromHub",
      render: (text) => <div>{capitalize(text)}</div>,
    },

    {
      title: "To Hub",
      dataIndex: "toHub",
      key: "toHub",
      render: (text) => <div>{capitalize(text)}</div>,
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNum",
      key: "vehicleNum",
    },
  ];

  const filterArray = (data, currValue) => {
    console.log(data, "data");
    return data?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setInputSearchValue(currValue);

    const filteredData =
      inputSearchValue.length > 0 || inputSearchValue.length == 0
        ? filterArray(tableData, currValue)
        : filterArray(tableData, currValue);
    setdataSource(filteredData);
    setTotal(filteredData?.length);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleStatus(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleStatus = async (id) => {
    console.log(id, "id");

    setLoading(true);
    let payload = {
      bagbarcode: [id],
      status: HUB_INSCANNED_LABEL,
    };

    // console.log(payload, "oatload");
    let response = await API.Api(UPDATE_ALL_BAGs).putIdHeader(payload);
    if (response.status) {
      setLoading(false);
      getLcrInscanList();
    }
    if (!response.status) {
      message.error(response.response.data.message);
      setLoading(false);
    }
  };

  function handlePageChange(pagination) {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
  }

  return (
    <div className="p-2">
      <Heading title="LCR List" />
      <div className="consolidated-manifest-cntr  mt-3">
        <div className="header" style={{ flexWrap: "wrap" }}>
          <div className="left">
            <Input
              placeholder="Enter barcode to scan"
              bordered
              // onChange={handleStatus}
              onChange={(e) => {
                // eslint-disable-next-line no-constant-condition
                if (e.target.value.length > 6) {
                  handleStatus(parseInt(e.target.value));
                }
              }}
              // style={{ borderRadius: "5px", height: "40px", width: "400px" }}
              style={{
                borderRadius: "5px",
                height: "40px",
                // width: "100%",
                margin: "15px 33px 15px 12px",
              }}
              suffix={<img src={search_icon} />}
            />
          </div>
          <div className="right">
            <Input
              placeholder="Enter keyword to search"
              bordered
              onChange={onSearch}
              // style={{ borderRadius: "5px", height: "40px", width: "400px" }}
              style={{
                borderRadius: "5px",
                height: "40px",
                // width: "100%",
                margin: "15px 12px 15px 12px",
              }}
              suffix={<img src={search_icon} />}
            />
          </div>
        </div>
        <Row>
          <Table
            columns={columns}
            className="lcr-inscan-container"
            // dataSource={mockData}
            dataSource={inputSearchValue.length == 0 ? tableData : dataSource}
            // pagination={{
            //   itemRender: itemRender,
            // }}
            pagination={{
              pageSize: pageSize,
              total: total,
              itemRender: itemRender,
              current: pageNum == 0 ? +1 : pageNum,
            }}
            onChange={handlePageChange}
            loading={loading}
          />
        </Row>
      </div>

      <div></div>
    </div>
  );
};

export default InScanLCRList;
